import v44Schema from "../client/schemaVersions/v44.js";
import v45Schema from "../client/schemaVersions/v45.js";
import { createMigration } from "@verdant-web/store";
export default createMigration(v44Schema, v45Schema, async ({ migrate }) => {
    // add or modify migration logic here. you must provide migrations for
    // any collections that have changed field types or added new non-nullable
    // fields without defaults
    // await migrate('collectionName', async (old) => ({ /* new */ }));
});
//# sourceMappingURL=v45.js.map